export const CERBER_BASE_URL = process.env.REACT_APP_CERBER_BASE_URL;

export const CERBER_JSONRPC_ENTRY_POINT = process.env.REACT_APP_CERBER_JSONRPC_ENTRY_POINT;
